import { render, staticRenderFns } from "./ExpenseDetail.vue?vue&type=template&id=086c4c9b&scoped=true&"
import script from "./ExpenseDetail.vue?vue&type=script&lang=js&"
export * from "./ExpenseDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDetail.vue?vue&type=style&index=0&id=086c4c9b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c4c9b",
  null
  
)

export default component.exports